import { render, staticRenderFns } from "./SlideListChild.vue?vue&type=template&id=6dfada65&scoped=true&"
import script from "./SlideListChild.vue?vue&type=script&lang=js&"
export * from "./SlideListChild.vue?vue&type=script&lang=js&"
import style0 from "./SlideListChild.vue?vue&type=style&index=0&id=6dfada65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfada65",
  null
  
)

export default component.exports